export default "__VITE_ASSET__DvUtAgS3__"